module.exports = __webpack_public_path__ + "img/enemy_111_003.866b83ea.png";